import React from "react";
import { useI18n } from "../i18n";

const steps = [
  {
    labelKey: "howItWorks.step1.label",
    titleKey: "howItWorks.step1.title",
    descKey: "howItWorks.step1.description",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
      </svg>
    ),
  },
  {
    labelKey: "howItWorks.step2.label",
    titleKey: "howItWorks.step2.title",
    descKey: "howItWorks.step2.description",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
      </svg>
    ),
  },
  {
    labelKey: "howItWorks.step3.label",
    titleKey: "howItWorks.step3.title",
    descKey: "howItWorks.step3.description",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
      </svg>
    ),
  },
];

export function HowItWorks() {
  const { t } = useI18n();

  return (
    <section id="how-it-works" className="py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t("howItWorks.title")}
          </h2>
          <p className="text-[#8a7a9a] text-lg max-w-2xl mx-auto">
            {t("howItWorks.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, i) => (
            <div key={step.titleKey} className="relative text-center">
              {/* Connector line between steps */}
              {i < steps.length - 1 && (
                <div className="hidden md:block onyx-step-connector" />
              )}

              <div className="flex flex-col items-center">
                <div className="onyx-step-number mb-4">
                  {i + 1}
                </div>

                <div className="w-10 h-10 rounded-lg bg-[#a078d0]/10 flex items-center justify-center text-[#c0a0e0] mb-4">
                  {step.icon}
                </div>

                <span className="text-xs font-semibold text-[#a078d0] uppercase tracking-wider mb-2">
                  {t(step.labelKey)}
                </span>

                <h3 className="text-xl font-semibold text-white mb-3">
                  {t(step.titleKey)}
                </h3>

                <p className="text-sm text-[#8a7a9a] leading-relaxed max-w-xs mx-auto">
                  {t(step.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
